import Modal from './Modal';

interface StockChange {
  item_code: string;
  item_name: string;
  location_name: string;
  stock_before: number;
  stock_after: number;
  quantity_changed: number;
}

interface StockChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  changes: StockChange[];
}

export default function StockChangeModal({ isOpen, onClose, title, changes }: StockChangeModalProps) {
  if (!isOpen || changes.length === 0) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="large"
      footer={
        <button className="btn btn-primary" onClick={onClose} data-modal-default="true">
          Cerrar
        </button>
      }
    >
      <div style={{ marginTop: '1rem' }}>
        <table className="table" style={{ marginBottom: '0' }}>
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Ubicación</th>
              <th style={{ textAlign: 'right' }}>Stock Anterior</th>
              <th style={{ textAlign: 'right' }}>Cantidad</th>
              <th style={{ textAlign: 'right' }}>Stock Nuevo</th>
            </tr>
          </thead>
          <tbody>
            {changes.map((change, index) => {
              const isIncrease = change.quantity_changed > 0;
              const quantityClass = isIncrease ? 'text-success' : 'text-error';
              
              return (
                <tr key={index}>
                  <td>{change.item_code}</td>
                  <td>{change.item_name}</td>
                  <td>{change.location_name}</td>
                  <td style={{ textAlign: 'right', fontWeight: '500' }}>
                    {change.stock_before.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 4 })}
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: '600' }} className={quantityClass}>
                    {isIncrease ? '+' : ''}
                    {change.quantity_changed.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 4 })}
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: '600' }}>
                    {change.stock_after.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 4 })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}

